import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TablePagination from "@mui/material/TablePagination";
import { Pagination } from "antd";
import { ToastContainer, toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import {
  get_meeting_transcript,
  getBlockByDistrict,
  getDistrict,
  getMOMDetails,
  getVillageByBlock,
  uploadMOM,
  generateSignedUrl,
} from "../../api/User";
import "../Admin/table.css";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import { Modal, TimePicker } from "antd";
import loader from "../../Images/ajax-loader.gif";
import { useNavigate } from "react-router-dom";
import { updateDataForMom } from "../../api/User.js";
import { updateGpVoterCount } from "../../api/User";
import dayjs from "dayjs";
const MAX_VIDEO_SIZE = 100 * 1024 * 1024; // 200 MB
const MAX_MOM_SIZE = 10 * 1024 * 1024; // 10 MB
const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB per image

const GramSabhaMOM = ({ dateFilter }) => {
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data");
  const token = sessionStorage.getItem("token");
  const [voterCount, setVoterCount] = useState(0);
  const [population, setPopulation] = useState(0);

  const navigate = useNavigate();

  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [files, setFiles] = useState([]);
  const [uploadType, setUploadType] = useState("video");

  const [momDocument, setMomDocumentUrl] = useState(null);
  const [visible, setVisible] = useState(false);
  const [transcriptData, setTranscriptData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");

  const [openEditModal, setOpenEditModal] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null); // Store current row data to check existing files

  // Attendance tracking state
  const [attendanceValues, setAttendanceValues] = useState({});
  const [updatingAttendance, setUpdatingAttendance] = useState({});

  const [voterEditValues, setVoterEditValues] = useState({});
  const [updatingVoter, setUpdatingVoter] = useState({});

  // Upload tracking - prevent multiple simultaneous uploads
  const [isUploading, setIsUploading] = useState(false);
  const [uploadingRowId, setUploadingRowId] = useState(null);

  const [previousImages, setPreviousImages] = useState([]);

  const [editFiles, setEditFiles] = useState({
    video: null,
    mom: null,
    images: {
      existing: [],
      new: [],
    },
  });

  const [editForm, setEditForm] = useState({
    sabha_date: "",
    sabha_start_time: "",
    venue: "",
  });
  const [originalEditForm, setOriginalEditForm] = useState({});

  // S3 signed URLs for viewing files in edit modal
  const [signedUrls, setSignedUrls] = useState({
    video: null,
    mom: null,
    images: [],
  });

  const handleEditFileChange = (type, files) => {
    if (!files || files.length === 0) return;

    if (type === "image") {
      const fileArray = Array.from(files);

      // Check each image size
      for (let file of fileArray) {
        if (file.size > MAX_IMAGE_SIZE) {
          toast.error(`Image "${file.name}" exceeds 5 MB limit.`, {
            autoClose: 2000,
          });
          return;
        }
      }

      setEditFiles((prev) => ({
        ...prev,
        images: {
          ...prev.images,
          new: fileArray,
        },
      }));
    } else {
      const file = files[0];

      // Video size validation
      if (type === "video" && file.size > MAX_VIDEO_SIZE) {
        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(`Video size (${sizeInMB} MB) exceeds 100 MB limit.`, {
          autoClose: 3000,
        });
        return;
      }

      // MOM size validation
      if (type === "mom" && file.size > MAX_MOM_SIZE) {
        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(`MOM document size (${sizeInMB} MB) exceeds 10 MB limit.`, {
          autoClose: 2000,
        });
        return;
      }

      setEditFiles((prev) => ({
        ...prev,
        [type]: file,
      }));
    }
  };
  // Generate signed URLs for existing files in edit modal
  const generateSignedUrlsForEdit = async (row) => {
    const urls = {
      video: null,
      mom: null,
      images: [],
    };

    try {
      // Generate signed URL for video
      if (row.video_file) {
        const videoRes = await generateSignedUrl(token, row.video_file, 3600);
        if (videoRes.status === "success") {
          urls.video = videoRes.data.signed_url;
        }
      }

      // Generate signed URL for MOM document
      if (row.mom_document) {
        const momRes = await generateSignedUrl(token, row.mom_document, 3600);
        if (momRes.status === "success") {
          urls.mom = momRes.data.signed_url;
        }
      }

      // Generate signed URLs for images
      if (row.image_upload && row.image_upload.length > 0) {
        const imagePromises = row.image_upload.map(async (img) => {
          try {
            const imgRes = await generateSignedUrl(token, img, 3600);
            if (imgRes.status === "success") {
              return {
                original: img,
                signed: imgRes.data.signed_url,
              };
            }
          } catch (err) {
            console.error("Error generating signed URL for image:", img, err);
          }
          return null;
        });

        const imageResults = await Promise.all(imagePromises);
        urls.images = imageResults.filter((img) => img !== null);
      }

      setSignedUrls(urls);
    } catch (error) {
      console.error("Error generating signed URLs:", error);
      toast.error("Failed to load file previews", { autoClose: 1500 });
    }
  };

  // const handleEditUpdate = async () => {
  //   if (!editRowId) return;

  //   // Prevent multiple uploads
  //   if (isUploading) {
  //     toast.warning("Please wait, upload in progress...", { autoClose: 1500 });
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     setIsUploading(true);
  //     let isUpdated = false;

  //     if (editFiles.video) {
  //       const fd = new FormData();
  //       fd.append("file", editFiles.video);
  //       fd.append("id", editRowId);
  //       fd.append("uploadType", "video");
  //       const res = await updateDataForMom(token, fd);
  //       if (res?.status === "success") isUpdated = true;
  //     }

  //     if (editFiles.mom) {
  //       const fd = new FormData();
  //       fd.append("file", editFiles.mom);
  //       fd.append("id", editRowId);
  //       fd.append("uploadType", "mom");
  //       const res = await updateDataForMom(token, fd);
  //       if (res?.status === "success") isUpdated = true;
  //     }

  //     if (editFiles.images.new.length > 0) {
  //       const fd = new FormData();
  //       editFiles.images.new.forEach((file) => {
  //         fd.append("file", file);
  //       });
  //       fd.append("id", editRowId);
  //       fd.append("uploadType", "image");
  //       const res = await updateDataForMom(token, fd);
  //       if (res?.status === "success") isUpdated = true;
  //     }

  //     if (isUpdated) {
  //       toast.success("MOM updated successfully");
  //       setOpenEditModal(false);
  //       fetchData();
  //     } else {
  //       toast.error("No files selected to update");
  //     }
  //   } catch (err) {
  //     console.error("EDIT UPDATE ERROR:", err);
  //     toast.error("Update failed");
  //   } finally {
  //     setLoading(false);
  //     setIsUploading(false);
  //   }
  // };

  // ==================== HELPER FUNCTIONS ====================

  /**
   * Normalize value for database operations
   * Converts empty strings and "नहीं" to empty string
   */
  const normalizeValue = (value) => {
    if (!value || value.trim() === "" || value.trim() === "नहीं") {
      return "";
    }
    return value.trim();
  };

  const todayYMD = () => {
    const d = new Date();

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // LOCAL YYYY-MM-DD
  };


  const sabhaDateYMD = (date) => {
    if (!date) return null;

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };



  /**
   * Check if meeting details (date, time, venue) have changed
   */
  const getMeetingDetailsChanges = () => {
    const originalDate = originalEditForm.sabha_date || "";
    const originalTime = originalEditForm.sabha_start_time || "";
    const originalVenue = originalEditForm.venue || "";

    const dateChanged = normalizeValue(editForm.sabha_date) !== normalizeValue(originalDate);
    const timeChanged = normalizeValue(editForm.sabha_start_time) !== normalizeValue(originalTime);
    const venueChanged = normalizeValue(editForm.venue) !== normalizeValue(originalVenue);

    return {
      dateChanged,
      timeChanged,
      venueChanged,
      anyMeetingDetailChanged: dateChanged || timeChanged || venueChanged
    };
  };

  /**
   * Check if any files have been selected for upload
   */
  const hasFilesToUpload = () => {
    return editFiles.video || editFiles.mom || editFiles.images.new.length > 0;
  };

  /**
   * Validate meeting date and time
   * Returns { isValid: boolean, errorMessage: string }
   */
  const validateMeetingDateTime = (dateChanged, timeChanged) => {
    // Only validate if date or time has changed
    if (!dateChanged && !timeChanged) {
      return { isValid: true, errorMessage: "" };
    }

    // Check if user is trying to schedule before the current sabha_date
    if (dateChanged && currentRowData?.sabha_date) {
      const originalDate = new Date(formatDateForDisplay(currentRowData.sabha_date));
      const newDate = new Date(editForm.sabha_date);

      // Uncommented: Allow rescheduling to earlier dates if needed
      // if (newDate < originalDate) {
      //   return {
      //     isValid: false,
      //     errorMessage: "Cannot schedule meeting before the current meeting date"
      //   };
      // }
    }

    // Check if selected date is today and validate time
    if (editForm.sabha_date === todayYMD()) {
      const isPast = isPastTimeForToday(editForm.sabha_date, editForm.sabha_start_time);
      if (isPast) {
        return {
          isValid: false,
          errorMessage: "Cannot select past time for today's date"
        };
      }
    }

    return { isValid: true, errorMessage: "" };
  };

  /**
   * Check if meeting date has passed (for disabling fields)
   */
  const isMeetingDatePassed = () => {
    if (!currentRowData?.sabha_date) return false;

    const today = todayYMD();
    const meetingDate = sabhaDateYMD(currentRowData.sabha_date);

    return today >= meetingDate;
  };


  // ==================== MAIN UPDATE HANDLER ====================

  const handleEditUpdate = async () => {
    if (!editRowId) return;

    if (isUploading) {
      toast.warning("Please wait, upload in progress...");
      return;
    }

    try {
      setLoading(true);
      setIsUploading(true);

      const fd = new FormData();
      let hasData = false;

      fd.append("id", editRowId);
      fd.append("updated_by", userId);

      // Get what has changed
      const changes = getMeetingDetailsChanges();

      // Validate meeting date/time only if they changed
      const validation = validateMeetingDateTime(changes.dateChanged, changes.timeChanged);
      if (!validation.isValid) {
        toast.error(validation.errorMessage);
        setLoading(false);
        setIsUploading(false);
        return;
      }

      // Add changed meeting details to FormData
      if (changes.dateChanged) {
        fd.append("sabha_date", normalizeValue(editForm.sabha_date) || "");
        hasData = true;
      }

      if (changes.timeChanged) {
        fd.append("sabha_start_time", normalizeValue(editForm.sabha_start_time) || "");
        hasData = true;
      }

      if (changes.venueChanged) {
        fd.append("venue", normalizeValue(editForm.venue) || "");
        hasData = true;
      }

      // Add files to FormData
      if (editFiles.video) {
        fd.append("mom_upload", editFiles.video);
        hasData = true;
      }

      if (editFiles.mom) {
        fd.append("mom_upload_document", editFiles.mom);
        hasData = true;
      }

      if (editFiles.images.new.length > 0) {
        editFiles.images.new.forEach((file) => fd.append("image_upload", file));
        hasData = true;
      }

      // Check if anything was changed
      if (!hasData) {
        toast.error("Please update at least one field");
        setLoading(false);
        setIsUploading(false);
        return;
      }

      // Submit update
      const res = await updateDataForMom(token, fd);

      if (res?.status === "success") {
        toast.success("Meeting updated successfully");
        setOpenEditModal(false);
        fetchData(selectedDistrict, selectedBlock, selectedVillage, page, rowsPerPage);
      } else {
        toast.error(res?.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Meeting already scheduled for this Panchayat on the selected date!");
    } finally {
      setLoading(false);
      setIsUploading(false);
    }
  };

  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token, userId, role_id);
      if (res.status === "success") {
        setDistricts(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(
        token,
        district_code,
        userId,
        role_id
      );
      if (res.status === "success") {
        setBlocks(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(
        token,
        district_code,
        block_code,
        userId,
        role_id
      );
      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchData = async (
    dist = selectedDistrict,
    block = selectedBlock,
    gp = selectedVillage,
    currentPage = page,
    currentLimit = rowsPerPage
  ) => {
    const data = {
      user_id: userId,
      role_id: role_id,
      meeting_type: "gram_sabha",
      // district_code: dist || null,
      // block_code: block || null,
      // gram_panchayat_code: gp || null,
    };
    if (dist && dist !== "") {
      data.district_code = dist;
    }

    if (block && block !== "") {
      data.block_code = block;
    }

    if (gp && gp !== "") {
      data.gram_panchayat_code = gp;
    }
    try {
      setLoading(true);
      const res = await getMOMDetails(token, data, currentPage + 1, currentLimit, dateFilter);
      if (res.status === "success") {
        const formattedData = res.data.map((item) => ({
          ...item,
          sabha_date: item.sabha_date
            ? formatDateForDisplay(item.sabha_date) // Use helper function
            : "",
          sabha_start_time: item.sabha_start_time
            ? item.sabha_start_time.substring(0, 5)
            : "",
          video_file: item.mom_upload || null,
          mom_document: item.mom_upload_document || null,
          image_upload: processImageUpload(item.image_upload),
        }));
        setFilteredData(formattedData);
        setTotalRecords(res.pagination?.total_records || 0);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", {
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";

    try {
      // If date is already in YYYY-MM-DD format, return as is
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }

      // If it's a date string with timezone info
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return dateString;
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };
  // Helper function to process image_upload data
  const processImageUpload = (imageUpload) => {
    if (!imageUpload) return [];

    // If it's already an array
    if (Array.isArray(imageUpload)) {
      return imageUpload.map((img) => cleanImageName(img));
    }

    // If it's a string
    if (typeof imageUpload === "string") {
      // Try to parse if it looks like a JSON array string
      try {
        // Check if it's a JSON string like '["image1.png", "image2.png"]'
        if (
          imageUpload.trim().startsWith("[") &&
          imageUpload.trim().endsWith("]")
        ) {
          const parsed = JSON.parse(imageUpload);
          if (Array.isArray(parsed)) {
            return parsed.map((img) => cleanImageName(img));
          }
        }

        // If it's a single string with brackets and quotes like '["image.png"]'
        const cleaned = imageUpload
          .replace(/^\[|\]$/g, "") // Remove outer brackets
          .replace(/^"|"$/g, "") // Remove outer quotes
          .trim();

        if (cleaned.includes(",")) {
          // Multiple images separated by commas
          return cleaned
            .split(",")
            .map((img) => img.trim())
            .filter((img) => img.length > 0)
            .map((img) => cleanImageName(img));
          console.log(imageUpload);
        } else if (cleaned) {
          // Single image
          return [cleanImageName(cleaned)];
        }
      } catch (error) {
        console.error("Error parsing meeting image upload:", error);
        console.log(imageUpload);
        // If parsing fails, treat it as a single string
        return [cleanImageName(imageUpload)];
      }
    }

    return [];
  };

  // Helper function to clean image path while preserving the full path
  const cleanImageName = (imgPath) => {
    if (!imgPath) return "";

    // Convert to string
    let cleaned = String(imgPath);

    // Remove any leading/trailing whitespace
    cleaned = cleaned.trim();

    // Remove quotes and brackets from start and end
    cleaned = cleaned.replace(/^["'\[]+|["'\]]+$/g, "");

    // Remove ANY dots from the beginning (handles cases like .image.png, ..image.png, etc.)
    cleaned = cleaned.replace(/^\.+/, "");

    // Now also remove any ./ or ../ patterns if they exist after removing initial dots
    cleaned = cleaned.replace(/^[\\\/]+/, "");

    // Keep the full path - don't extract just the filename
    // This preserves paths like "uploads/meetings_mom/1769598167135_image_100_1767958870525.jpg"

    // Final trim to remove any leftover whitespace
    return cleaned.trim();
  };


  // Add this function with your other helper functions
  const downloadImage = async (url, filename) => {
    try {
      // Create an anchor element
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'image.jpg';
      link.target = '_blank';

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Fallback for Safari and certain browsers
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download image');
    }
  };

  useEffect(() => {
    fetchData();
    fetchDistricts();
  }, []);

  // Re-fetch when dateFilter changes
  useEffect(() => {
    fetchData(selectedDistrict, selectedBlock, selectedVillage, page, rowsPerPage);
  }, [dateFilter]);

  const handleDistrictChange = (value) => {
    setSelectedDistrict(value);
    setSelectedBlock("");
    setSelectedVillage("");
    setBlocks([]);
    setVillages([]);
    setPage(0);
    if (value) fetchBlocks(value);
    // Only pass value if it's truthy
    fetchData(value, "", "", 0, rowsPerPage);
  };

  const handleBlockChange = (value) => {
    setSelectedBlock(value);
    setSelectedVillage("");
    setVillages([]);
    setPage(0);
    if (value) fetchVillages(selectedDistrict, value);
    // Only pass selectedDistrict if it has a value
    fetchData(selectedDistrict, value, "", 0, rowsPerPage);
  };

  const handleVillageChange = (value) => {
    setSelectedVillage(value);
    setPage(0);
    // Only pass parameters that have values
    fetchData(selectedDistrict, selectedBlock, value, 0, rowsPerPage);
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);

    if (selectedFiles.length === 0) return;

    /* ===================== VIDEO ===================== */
    if (uploadType === "video") {
      const file = selectedFiles[0];

      const allowedTypes = [
        "video/mp4",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-matroska",
      ];

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only MP4, MOV, AVI, MKV videos are allowed.", {
          autoClose: 1500,
        });
        event.target.value = "";
        setFiles([]);
        return;
      }

      // ADD 100MB VALIDATION
      if (file.size > MAX_VIDEO_SIZE) {
        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(`Video size (${sizeInMB} MB) exceeds 100 MB limit. Please upload a smaller video.`, {
          autoClose: 3000, // Longer timeout for bigger message
        });
        event.target.value = "";
        setFiles([]);
        return;
      }

      setFiles([file]);
    } else if (uploadType === "mom") {
      /* ===================== MOM ===================== */
      const file = selectedFiles[0];

      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      const allowedExt = ["pdf", "doc", "docx"];
      const ext = file.name.toLowerCase().split(".").pop();

      if (!allowedTypes.includes(file.type) && !allowedExt.includes(ext)) {
        toast.error("Only PDF, DOC, DOCX files are allowed for MOM.", {
          autoClose: 1500,
        });
        event.target.value = "";
        setFiles([]);
        return;
      }

      if (file.size > MAX_MOM_SIZE) {
        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(`MOM document size (${sizeInMB} MB) exceeds 10 MB limit.`, {
          autoClose: 2000,
        });
        event.target.value = "";
        setFiles([]);
        return;
      }

      setFiles([file]);
    } else if (uploadType === "image") {
      /* ===================== IMAGES ===================== */
      const validImages = [];

      for (let file of selectedFiles) {
        if (!file.type.startsWith("image/")) {
          toast.error("Only image files are allowed.", { autoClose: 1500 });
          event.target.value = "";
          setFiles([]);
          return;
        }

        if (file.size > MAX_IMAGE_SIZE) {
          const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
          toast.error(`Image "${file.name}" (${sizeInMB} MB) exceeds 5 MB limit.`, {
            autoClose: 2000,
          });
          event.target.value = "";
          setFiles([]);
          return;
        }

        validImages.push(file);
      }

      if (validImages.length === 0) {
        toast.error("Please select valid image files.", { autoClose: 1500 });
        event.target.value = "";
        setFiles([]);
        return;
      }

      setFiles(validImages);
    }
  };
  const handleUpload = async () => {
    if (!files.length || !selectedRowId) return;

    // Prevent multiple simultaneous uploads
    if (isUploading) {
      toast.warning("Please wait, another upload is in progress...", {
        autoClose: 1500,
      });
      return;
    }

    const mainFile = files[0];
    const formData = new FormData();
    files.forEach((f) => formData.append("file", f));
    formData.append("id", selectedRowId);
    formData.append("fileType", mainFile.type);
    formData.append("uploadType", uploadType);

    try {
      setLoading(true);
      setIsUploading(true);
      setUploadingRowId(selectedRowId);

      const res = await uploadMOM(token, formData);

      if (res.status === "success") {
        toast.success("File(s) uploaded successfully!", { autoClose: 1000 });

        // Reset state BEFORE closing modal to prevent re-triggering
        setFiles([]);
        const currentRowId = selectedRowId;
        setSelectedRowId(null);
        setUploadingRowId(null);
        setIsUploading(false);
        setLoading(false);
        setOpenUploadModal(false);

        // Fetch updated data
        fetchData(selectedDistrict, selectedBlock, selectedVillage, page, rowsPerPage);
      } else {
        toast.error(
          res.message ||
          "File has already has been uploaded. Please use the Edit option to update the file",
          {
            autoClose: 1500,
          }
        );
        setLoading(false);
        setIsUploading(false);
        setUploadingRowId(null);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("An error occurred while uploading the file.", {
        autoClose: 1500,
      });
      setLoading(false);
      setIsUploading(false);
      setUploadingRowId(null);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData(selectedDistrict, selectedBlock, selectedVillage, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    fetchData(selectedDistrict, selectedBlock, selectedVillage, 0, newLimit);
  };

  const paginatedData = filteredData;

  const handleCloseModal = () => {
    setVisible(false);
  };

  const handleBeneficiaryDetails = (row) => {
    if (!row || !row.id) {
      toast.error("Invalid meeting selection.", { autoClose: 1000 });
      return;
    }
    navigate("/beneficiary-screen", {
      state: {
        meetingId: row.id,
        gramPanchayat: row.panchayat_name,
        meetingDate: row.sabha_date,
        meetingTime: row.sabha_start_time,
        venue: row.venue,
        villageCode: row.gram_panchayat_code,
        villageName: row.village_name ?? "",
      },
    });
  };
  const handleDevelopmentWork = (row) => {
    // Store in sessionStorage for persistence across page reloads
    const meetingData = {
      district_code: row.district_code || row.district_id || row.district || row.dist_code,
      block_code: row.block_code || row.block_id || row.block || row.blk_code,
      gram_panchayat_code: row.gram_panchayat_code || row.gram_panchayat_id || row.panchayat_code,
      meeting_id: row.id || row.meeting_id || row.sched_meet_id,
      panchayat_name: row.panchayat_name,
      sabha_date: row.sabha_date,
      venue: row.venue,
    };

    sessionStorage.setItem("current_meeting", JSON.stringify(meetingData));

    // Also pass in state for immediate access
    navigate("/development-work", {
      state: meetingData,
    });
  };

  const handleAmritSarovar = (row) => {
    // Store in sessionStorage for persistence across page reloads
    const meetingData = {
      district_code: row.district_code || row.district_id || row.district || row.dist_code,
      block_code: row.block_code || row.block_id || row.block || row.blk_code,
      gram_panchayat_code: row.gram_panchayat_code || row.gram_panchayat_id || row.panchayat_code,
      meeting_id: row.id || row.meeting_id || row.sched_meet_id,
      panchayat_name: row.panchayat_name,
      sabha_date: row.sabha_date,
      venue: row.venue,
    };

    sessionStorage.setItem("current_meeting", JSON.stringify(meetingData));

    // Also pass in state for immediate access
    navigate("/amrit-sarovar", {
      state: meetingData,
    });
  };

  const handleAttendanceChange = (rowId, value) => {
    const numValue = parseInt(value, 10);
    if (value === "" || (numValue >= 0 && !isNaN(numValue))) {
      setAttendanceValues((prev) => ({
        ...prev,
        [rowId]: value === "" ? "" : numValue,
      }));
    }
  };

  const handleAttendanceUpdate = async (rowId) => {
    if (isUploading || updatingAttendance[rowId]) {
      toast.warning("Please wait, operation in progress...", {
        autoClose: 1500,
      });
      return;
    }

    const attendanceValue = attendanceValues[rowId];

    // ❌ VALIDATION FIRST
    if (
      attendanceValue === undefined ||
      attendanceValue === "" ||
      Number(attendanceValue) === 0
    ) {
      toast.error("Please enter attendance before saving", {
        autoClose: 1500,
      });
      return;
    }

    const valueToSave = Number(attendanceValue);

    if (isNaN(valueToSave) || valueToSave < 0) {
      toast.error("Please enter a valid attendance number", {
        autoClose: 1500,
      });
      return;
    }

    // ✅ CONFIRMATION POPUP
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save this attendance?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#4763E4",
      cancelButtonColor: "#d33",
    });

    if (!result.isConfirmed) {
      return; // ❌ User cancelled
    }

    try {
      setUpdatingAttendance((prev) => ({ ...prev, [rowId]: true }));

      const res = await updateDataForMom(token, {
        id: rowId,
        gram_sabha_attendance: valueToSave,
      });

      if (res.status === "success") {
        toast.success("Attendance saved successfully!", {
          autoClose: 1000,
        });

        setAttendanceValues((prev) => {
          const newState = { ...prev };
          delete newState[rowId];
          return newState;
        });

        fetchData(selectedDistrict, selectedBlock, selectedVillage, page, rowsPerPage);
      } else {
        toast.error(res.message || "Failed to save attendance");
      }
    } catch (error) {
      toast.error("An error occurred while saving attendance.");
    } finally {
      setUpdatingAttendance((prev) => ({ ...prev, [rowId]: false }));
    }
  };

  const handleVoterChange = (rowId, value) => {
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      setVoterEditValues((prev) => ({
        ...prev,
        [rowId]: value,
      }));
    }
  };

  const handleVoterSave = async (row) => {
    const value = voterEditValues[row.id];

    if (value === undefined || value === "") {
      toast.error("Please enter voter count");
      return;
    }

    const result = await Swal.fire({
      title: "Confirm Update",
      text: "Do you want to save voter count?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save",
    });

    if (!result.isConfirmed) return;

    try {
      setUpdatingVoter((prev) => ({ ...prev, [row.id]: true }));

      const res = await updateGpVoterCount(token, {
        panchayat_code: row.gram_panchayat_code,
        gp_voter_count: Number(value),
      });

      if (res.status === "success") {
        toast.success("Voter count updated");
        fetchData(selectedDistrict, selectedBlock, selectedVillage, page, rowsPerPage);

        setVoterEditValues((prev) => {
          const copy = { ...prev };
          delete copy[row.id];
          return copy;
        });
      } else {
        toast.error(res.message || "Update failed");
      }
    } catch (err) {
      toast.error("Failed to update voter count");
    } finally {
      setUpdatingVoter((prev) => ({ ...prev, [row.id]: false }));
    }
  };

  // Check if upload button should be disabled for a row
  const isUploadDisabled = (rowId) => {
    return isUploading && uploadingRowId !== rowId;
  };

  // Check if all required files are uploaded
  const isEditAllowed = (row) => {
    const hasVideo = !!row.video_file;
    const hasMom = !!row.mom_document;
    const hasImages =
      row.image_upload && Array.isArray(row.image_upload) && row.image_upload.length > 0;

    return hasVideo && hasMom && hasImages;
  };


  // Compact table cell style
  const cellStyle = {
    padding: "6px 8px",
    fontSize: "12px",
    whiteSpace: "nowrap",
    textAlign: "center",
  };

  const headerCellStyle = {
    padding: "8px 6px",
    fontSize: "11px",
    fontWeight: "600",
    whiteSpace: "normal",
    textAlign: "center",
    backgroundColor: "#2E4A8E",
    color: "white",
  };

  // Compact button style
  const compactBtnStyle = {
    fontSize: "10px",
    padding: "4px 8px",
    minWidth: "70px",
    backgroundColor: "#4763E420",
    color: "#4763E4",
    textTransform: "none",
    "&:hover": { backgroundColor: "#4763E4", color: "#fff" },
    "&:disabled": { backgroundColor: "#ccc", color: "#666" },
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const isPastTimeForToday = (selectedDate, selectedTime) => {
    if (!selectedDate || !selectedTime) return false;

    const today = new Date().toISOString().split("T")[0];

    if (selectedDate === today) {
      const now = new Date();
      const [hours, minutes] = selectedTime.split(":").map(Number);
      const selectedDateTime = new Date();
      selectedDateTime.setHours(hours, minutes, 0, 0);

      return selectedDateTime < now;
    }

    return false;
  };

  return (
    <>
      {/* Loading Overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={loader}
            alt="Loading..."
            style={{ width: "50px", height: "50px" }}
          />
        </div>
      )}

      <style>{`
        .MuiTablePagination-actions svg { visibility: visible !important; fill: #212128; }
        .compact-table .MuiTableCell-root { padding: 6px 8px !important; }
      `}</style>

      <div
        className="container-fluid"
        style={{ padding: "12px", minHeight: "90vh" }}
      >
        {/* Header */}
        <h4
          style={{ margin: "0 0 12px 0", fontWeight: "600", color: "#2E4A8E" }}
        >
          Gram Sabha - Meeting
        </h4>

        {/* Table Container */}
        <div
          style={{
            overflowX: "auto",
            maxHeight: "calc(100vh - 140px)",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            backgroundColor: "#fff",
          }}
        >
          {(role_id === "2" || role_id === "3") && (
            <Table size="small" className="compact-table">
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                  <TableCell style={headerCellStyle}>Gram Panchayat</TableCell>
                  <TableCell style={headerCellStyle}>Date</TableCell>
                  <TableCell style={headerCellStyle}>Time</TableCell>
                  <TableCell style={headerCellStyle}>Venue</TableCell>
                  <TableCell style={headerCellStyle}>Meeting Video</TableCell>
                  <TableCell style={headerCellStyle}>Proceeding book</TableCell>
                  <TableCell style={headerCellStyle}>Meeting Image</TableCell>
                  <TableCell style={headerCellStyle}>Beneficiary</TableCell>
                  <TableCell style={headerCellStyle}>
                    Total Population
                  </TableCell>
                  <TableCell style={headerCellStyle}>Voter Count</TableCell>
                  <TableCell style={headerCellStyle}>Attendance</TableCell>

                  <TableCell style={headerCellStyle}>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      }}
                    >
                      <TableCell style={cellStyle} align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell style={cellStyle}>
                        {row.panchayat_name}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {formatDateForDisplay(row.sabha_date)}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_start_time}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.venue}</TableCell>

                      {/* Upload Video */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("video");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Video Upload
                        </Button>
                      </TableCell>

                      {/* Upload MOM */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("mom");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Proceeding Book Upload
                        </Button>
                      </TableCell>

                      {/* Upload Images */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }

                            setSelectedRowId(row.id);
                            setUploadType("image");

                            // ✅ STORE PREVIOUS IMAGE NAMES
                            setPreviousImages(row.image_upload || []); // adjust key if backend sends differently

                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Image Upload
                        </Button>
                      </TableCell>

                      {/* Beneficiary Details */}
                      <TableCell style={cellStyle} align="center">
                        <span
                          style={{
                            color: "#4763E4",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "11px",
                          }}
                          onClick={() => handleBeneficiaryDetails(row)}
                        >
                          Details
                        </span>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          {row.gp_ppp_population > 0
                            ? row.gp_ppp_population
                            : 0}
                        </div>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <TableCell style={cellStyle} align="center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="number"
                              min="0"
                              value={
                                voterEditValues[row.id] !== undefined
                                  ? voterEditValues[row.id]
                                  : row.gp_voter_count || ""
                              }
                              onChange={(e) =>
                                handleVoterChange(row.id, e.target.value)
                              }
                              style={{
                                width: "60px",
                                padding: "3px",
                                fontSize: "11px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "3px",
                              }}
                            />

                            <Button
                              size="small"
                              variant="contained"
                              disabled={updatingVoter[row.id]}
                              sx={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                minWidth: "45px",
                                backgroundColor: "#4763E4",
                                "&:disabled": { backgroundColor: "#ccc" },
                              }}
                              onClick={() => handleVoterSave(row)}
                            >
                              {updatingVoter[row.id] ? "..." : "Save"}
                            </Button>
                          </div>
                        </TableCell>
                      </TableCell>

                      {/* Attendance */}
                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <input
                            type="number"
                            min="0"
                            value={
                              attendanceValues[row.id] !== undefined
                                ? attendanceValues[row.id]
                                : row.gram_sabha_attendance || ""
                            }
                            onChange={(e) =>
                              handleAttendanceChange(row.id, e.target.value)
                            }
                            style={{
                              width: "50px",
                              padding: "3px 4px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                            placeholder="0"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={updatingAttendance[row.id] || isUploading}
                            sx={{
                              fontSize: "9px",
                              padding: "2px 6px",
                              minWidth: "45px",
                              backgroundColor: "#4763E4",
                              "&:disabled": { backgroundColor: "#ccc" },
                            }}
                            onClick={() => handleAttendanceUpdate(row.id)}
                          >
                            {updatingAttendance[row.id] ? "..." : "Save"}
                          </Button>
                        </div>
                      </TableCell>

                      {/* Edit */}
                      <TableCell style={cellStyle} align="center">
                        <IconButton
                          size="small"
                          disabled={isUploading}

                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setEditRowId(row.id);
                            setCurrentRowData(row); // Store current row data to check existing files
                            // In the edit modal initialization:
                            setEditForm({
                              sabha_date:
                                formatDateForDisplay(row.sabha_date) || "",
                              sabha_start_time: row.sabha_start_time || "",
                              venue: row.venue || "",
                            });
                            setOriginalEditForm({
                              sabha_date:
                                formatDateForDisplay(row.sabha_date) || "",
                              sabha_start_time: row.sabha_start_time || "",
                              venue: row.venue || "",
                            });
                            setEditFiles({
                              video: null,
                              mom: null,
                              images: { existing: [], new: [] },
                            });
                            // Generate signed URLs for existing files
                            generateSignedUrlsForEdit(row);
                            setOpenEditModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}

          {role_id === "7" && (
            <Table size="small" className="compact-table">
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                  <TableCell style={headerCellStyle}>Ditrict</TableCell>
                  <TableCell style={headerCellStyle}>Block</TableCell>
                  <TableCell style={headerCellStyle}>Gram Panchayat</TableCell>
                  <TableCell style={headerCellStyle}>Date</TableCell>
                  <TableCell style={headerCellStyle}>Time</TableCell>
                  <TableCell style={headerCellStyle}>Venue</TableCell>
                  <TableCell style={headerCellStyle}>Video</TableCell>
                  <TableCell style={headerCellStyle}>MOM</TableCell>
                  <TableCell style={headerCellStyle}>Images</TableCell>
                  <TableCell style={headerCellStyle}>Beneficiary</TableCell>
                  <TableCell style={headerCellStyle}>
                    Total Population
                  </TableCell>
                  <TableCell style={headerCellStyle}>Voter Count</TableCell>
                  <TableCell style={headerCellStyle}>Attendance</TableCell>
                  <TableCell style={headerCellStyle}>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      }}
                    >
                      <TableCell style={cellStyle} align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell style={cellStyle}>
                        {row.district_name}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.block_name}</TableCell>
                      <TableCell style={cellStyle}>
                        {row.panchayat_name}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_date}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_start_time}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.venue}</TableCell>

                      {/* Upload Video */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("video");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Video Upload
                        </Button>
                      </TableCell>

                      {/* Upload MOM */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("mom");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Proceeding Book Upload
                        </Button>
                      </TableCell>

                      {/* Upload Images */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }

                            setSelectedRowId(row.id);
                            setUploadType("image");

                            // ✅ STORE PREVIOUS IMAGE NAMES
                            setPreviousImages(row.image_upload || []); // adjust key if backend sends differently

                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Image Upload
                        </Button>
                      </TableCell>

                      {/* Beneficiary Details */}
                      <TableCell style={cellStyle} align="center">
                        <span
                          style={{
                            color: "#4763E4",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "11px",
                          }}
                          onClick={() => handleBeneficiaryDetails(row)}
                        >
                          Details
                        </span>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          {row.gp_ppp_population > 0
                            ? row.gp_ppp_population
                            : 0}
                        </div>
                      </TableCell>

                      {/* Attendance */}
                      <TableCell style={cellStyle} align="center">
                        <TableCell style={cellStyle} align="center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="number"
                              min="0"
                              value={
                                voterEditValues[row.id] !== undefined
                                  ? voterEditValues[row.id]
                                  : row.gp_voter_count || ""
                              }
                              onChange={(e) =>
                                handleVoterChange(row.id, e.target.value)
                              }
                              style={{
                                width: "60px",
                                padding: "3px",
                                fontSize: "11px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "3px",
                              }}
                            />

                            <Button
                              size="small"
                              variant="contained"
                              disabled={updatingVoter[row.id]}
                              sx={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                minWidth: "45px",
                                backgroundColor: "#4763E4",
                                "&:disabled": { backgroundColor: "#ccc" },
                              }}
                              onClick={() => handleVoterSave(row)}
                            >
                              {updatingVoter[row.id] ? "..." : "Save"}
                            </Button>
                          </div>
                        </TableCell>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <input
                            type="number"
                            min="0"
                            value={
                              attendanceValues[row.id] !== undefined
                                ? attendanceValues[row.id]
                                : row.gram_sabha_attendance || ""
                            }
                            onChange={(e) =>
                              handleAttendanceChange(row.id, e.target.value)
                            }
                            style={{
                              width: "50px",
                              padding: "3px 4px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                            placeholder="0"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={updatingAttendance[row.id] || isUploading}
                            sx={{
                              fontSize: "9px",
                              padding: "2px 6px",
                              minWidth: "45px",
                              backgroundColor: "#4763E4",
                              "&:disabled": { backgroundColor: "#ccc" },
                            }}
                            onClick={() => handleAttendanceUpdate(row.id)}
                          >
                            {updatingAttendance[row.id] ? "..." : "Save"}
                          </Button>
                        </div>
                      </TableCell>

                      {/* Edit */}
                      <TableCell style={cellStyle} align="center">
                        <IconButton
                          size="small"
                          disabled={isUploading}

                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setEditRowId(row.id);
                            setCurrentRowData(row); // Store current row data to check existing files

                            const formData = {
                              sabha_date: row.sabha_date || "",
                              sabha_start_time: row.sabha_start_time || "",
                              venue: row.venue || "",
                            };

                            setEditForm(formData);
                            setOriginalEditForm(formData);

                            setEditFiles({
                              video: null,
                              mom: null,
                              images: { existing: [], new: [] },
                            });

                            // Generate signed URLs for existing files
                            generateSignedUrlsForEdit(row);
                            setOpenEditModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}

          {role_id === "8" && (
            <Table size="small" className="compact-table">
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                  <TableCell style={headerCellStyle}>Ditrict</TableCell>
                  <TableCell style={headerCellStyle}>Block</TableCell>
                  <TableCell style={headerCellStyle}>Gram Panchayat</TableCell>
                  <TableCell style={headerCellStyle}>Date</TableCell>
                  <TableCell style={headerCellStyle}>Time</TableCell>
                  <TableCell style={headerCellStyle}>Venue</TableCell>
                  <TableCell style={headerCellStyle}>Video</TableCell>
                  <TableCell style={headerCellStyle}>MOM</TableCell>
                  <TableCell style={headerCellStyle}>Images</TableCell>
                  <TableCell style={headerCellStyle}>Beneficiary</TableCell>
                  <TableCell style={headerCellStyle}>
                    Total Population
                  </TableCell>
                  <TableCell style={headerCellStyle}>Voter Count</TableCell>
                  <TableCell style={headerCellStyle}>Attendance</TableCell>
                  <TableCell style={headerCellStyle}>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      }}
                    >
                      <TableCell style={cellStyle} align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell style={cellStyle}>
                        {row.district_name}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.block_name}</TableCell>
                      <TableCell style={cellStyle}>
                        {row.panchayat_name}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_date}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_start_time}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.venue}</TableCell>

                      {/* Upload Video */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("video");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Video Upload
                        </Button>
                      </TableCell>

                      {/* Upload MOM */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("mom");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Proceeding Book Upload
                        </Button>
                      </TableCell>

                      {/* Upload Images */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }

                            setSelectedRowId(row.id);
                            setUploadType("image");

                            // ✅ STORE PREVIOUS IMAGE NAMES
                            setPreviousImages(row.image_upload || []); // adjust key if backend sends differently

                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Image Upload
                        </Button>
                      </TableCell>

                      {/* Beneficiary Details */}
                      <TableCell style={cellStyle} align="center">
                        <span
                          style={{
                            color: "#4763E4",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "11px",
                          }}
                          onClick={() => handleBeneficiaryDetails(row)}
                        >
                          Details
                        </span>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          {row.gp_ppp_population > 0
                            ? row.gp_ppp_population
                            : 0}
                        </div>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <TableCell style={cellStyle} align="center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="number"
                              min="0"
                              value={
                                voterEditValues[row.id] !== undefined
                                  ? voterEditValues[row.id]
                                  : row.gp_voter_count || ""
                              }
                              onChange={(e) =>
                                handleVoterChange(row.id, e.target.value)
                              }
                              style={{
                                width: "60px",
                                padding: "3px",
                                fontSize: "11px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "3px",
                              }}
                            />

                            <Button
                              size="small"
                              variant="contained"
                              disabled={updatingVoter[row.id]}
                              sx={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                minWidth: "45px",
                                backgroundColor: "#4763E4",
                                "&:disabled": { backgroundColor: "#ccc" },
                              }}
                              onClick={() => handleVoterSave(row)}
                            >
                              {updatingVoter[row.id] ? "..." : "Save"}
                            </Button>
                          </div>
                        </TableCell>
                      </TableCell>

                      {/* Attendance */}
                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <input
                            type="number"
                            min="0"
                            value={
                              attendanceValues[row.id] !== undefined
                                ? attendanceValues[row.id]
                                : row.gram_sabha_attendance || ""
                            }
                            onChange={(e) =>
                              handleAttendanceChange(row.id, e.target.value)
                            }
                            style={{
                              width: "50px",
                              padding: "3px 4px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                            placeholder="0"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={updatingAttendance[row.id] || isUploading}
                            sx={{
                              fontSize: "9px",
                              padding: "2px 6px",
                              minWidth: "45px",
                              backgroundColor: "#4763E4",
                              "&:disabled": { backgroundColor: "#ccc" },
                            }}
                            onClick={() => handleAttendanceUpdate(row.id)}
                          >
                            {updatingAttendance[row.id] ? "..." : "Save"}
                          </Button>
                        </div>
                      </TableCell>

                      {/* Edit */}
                      <TableCell style={cellStyle} align="center">
                        <IconButton
                          size="small"
                          disabled={isUploading}

                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setEditRowId(row.id);
                            setCurrentRowData(row); // Store current row data to check existing files

                            const formData = {
                              sabha_date: formatDateForDisplay(row.sabha_date) || "",
                              sabha_start_time: row.sabha_start_time || "",
                              venue: row.venue || "",
                            };

                            setEditForm(formData);
                            setOriginalEditForm(formData);

                            setEditFiles({
                              video: null,
                              mom: null,
                              images: { existing: [], new: [] },
                            });

                            // Generate signed URLs for existing files
                            generateSignedUrlsForEdit(row);
                            setOpenEditModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}

          {role_id === "1" && (
            <Table size="small" className="compact-table">
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                  <TableCell style={headerCellStyle}>Ditrict</TableCell>
                  <TableCell style={headerCellStyle}>Block</TableCell>
                  <TableCell style={headerCellStyle}>Gram Panchayat</TableCell>
                  <TableCell style={headerCellStyle}>Date</TableCell>
                  <TableCell style={headerCellStyle}>Time</TableCell>
                  <TableCell style={headerCellStyle}>Venue</TableCell>
                  <TableCell style={headerCellStyle}>Video</TableCell>
                  <TableCell style={headerCellStyle}>MOM</TableCell>
                  <TableCell style={headerCellStyle}>Images</TableCell>
                  <TableCell style={headerCellStyle}>Beneficiary</TableCell>
                  <TableCell style={headerCellStyle}>
                    Total Population
                  </TableCell>
                  <TableCell style={headerCellStyle}>Voter Count</TableCell>
                  <TableCell style={headerCellStyle}>Attendance</TableCell>
                  <TableCell style={headerCellStyle}>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      }}
                    >
                      <TableCell style={cellStyle} align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell style={cellStyle}>
                        {row.district_name}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.block_name}</TableCell>
                      <TableCell style={cellStyle}>
                        {row.panchayat_name}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_date}
                      </TableCell>
                      <TableCell style={cellStyle} align="center">
                        {row.sabha_start_time}
                      </TableCell>
                      <TableCell style={cellStyle}>{row.venue}</TableCell>

                      {/* Upload Video */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("video");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Video Upload
                        </Button>
                      </TableCell>

                      {/* Upload MOM */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setSelectedRowId(row.id);
                            setUploadType("mom");
                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Proceeding Book Upload
                        </Button>
                      </TableCell>

                      {/* Upload Images */}
                      <TableCell style={cellStyle} align="center">
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isUploadDisabled(row.id)}
                          sx={compactBtnStyle}
                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }

                            setSelectedRowId(row.id);
                            setUploadType("image");

                            // ✅ STORE PREVIOUS IMAGE NAMES
                            setPreviousImages(row.image_upload || []); // adjust key if backend sends differently

                            setFiles([]);
                            setOpenUploadModal(true);
                          }}
                        >
                          Meeting Image Upload
                        </Button>
                      </TableCell>

                      {/* Beneficiary Details */}
                      <TableCell style={cellStyle} align="center">
                        <span
                          style={{
                            color: "#4763E4",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "11px",
                          }}
                          onClick={() => handleBeneficiaryDetails(row)}
                        >
                          Details
                        </span>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          {row.gp_ppp_population > 0
                            ? row.gp_ppp_population
                            : 0}
                        </div>
                      </TableCell>

                      <TableCell style={cellStyle} align="center">
                        <TableCell style={cellStyle} align="center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="number"
                              min="0"
                              value={
                                voterEditValues[row.id] !== undefined
                                  ? voterEditValues[row.id]
                                  : row.gp_voter_count || ""
                              }
                              onChange={(e) =>
                                handleVoterChange(row.id, e.target.value)
                              }
                              style={{
                                width: "60px",
                                padding: "3px",
                                fontSize: "11px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "3px",
                              }}
                            />

                            <Button
                              size="small"
                              variant="contained"
                              disabled={updatingVoter[row.id]}
                              sx={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                minWidth: "45px",
                                backgroundColor: "#4763E4",
                                "&:disabled": { backgroundColor: "#ccc" },
                              }}
                              onClick={() => handleVoterSave(row)}
                            >
                              {updatingVoter[row.id] ? "..." : "Save"}
                            </Button>
                          </div>
                        </TableCell>
                      </TableCell>

                      {/* Attendance */}
                      <TableCell style={cellStyle} align="center">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <input
                            type="number"
                            min="0"
                            value={
                              attendanceValues[row.id] !== undefined
                                ? attendanceValues[row.id]
                                : row.gram_sabha_attendance || ""
                            }
                            onChange={(e) =>
                              handleAttendanceChange(row.id, e.target.value)
                            }
                            style={{
                              width: "50px",
                              padding: "3px 4px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                            placeholder="0"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={updatingAttendance[row.id] || isUploading}
                            sx={{
                              fontSize: "9px",
                              padding: "2px 6px",
                              minWidth: "45px",
                              backgroundColor: "#4763E4",
                              "&:disabled": { backgroundColor: "#ccc" },
                            }}
                            onClick={() => handleAttendanceUpdate(row.id)}
                          >
                            {updatingAttendance[row.id] ? "..." : "Save"}
                          </Button>
                        </div>
                      </TableCell>

                      {/* Edit */}
                      <TableCell style={cellStyle} align="center">
                        <IconButton
                          size="small"
                          disabled={isUploading}

                          onClick={() => {
                            if (isUploading) {
                              toast.warning(
                                "Please complete current upload first",
                                { autoClose: 1500 }
                              );
                              return;
                            }
                            setEditRowId(row.id);
                            setCurrentRowData(row); // Store current row data to check existing files

                            const formData = {
                              sabha_date: formatDateForDisplay(row.sabha_date) || "",
                              sabha_start_time: row.sabha_start_time || "",
                              venue: row.venue || "",
                            };

                            setEditForm(formData);
                            setOriginalEditForm(formData);

                            setEditFiles({
                              video: null,
                              mom: null,
                              images: { existing: [], new: [] },
                            });

                            // Generate signed URLs for existing files
                            generateSignedUrlsForEdit(row);
                            setOpenEditModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </div>

        {/* Pagination - Only show when there is data */}
        {filteredData.length > 0 && (
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ fontSize: "13px" }}>
              {page * rowsPerPage + 1}-
              {Math.min((page + 1) * rowsPerPage, totalRecords)} of {totalRecords} records
            </div>

            <Pagination
              current={page + 1}
              pageSize={rowsPerPage}
              total={totalRecords}
              showSizeChanger
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={(newPage, newPageSize) => {
                setPage(newPage - 1);
                setRowsPerPage(newPageSize);
                fetchData(
                  selectedDistrict,
                  selectedBlock,
                  selectedVillage,
                  newPage - 1,
                  newPageSize
                );
              }}
            />
          </div>
        )}

        {/* Upload Modal */}
        <Dialog
          open={openUploadModal}
          onClose={() => {
            if (!isUploading) {
              setOpenUploadModal(false);
              setFiles([]);
            }
          }}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ py: 1.5, fontSize: "14px", fontWeight: 600 }}>
            {uploadType === "video"
              ? "Upload Video"
              : uploadType === "mom"
                ? "Upload MOM"
                : "Upload Images"}
            <IconButton
              onClick={() => {
                if (!isUploading) {
                  setOpenUploadModal(false);
                  setFiles([]);
                }
              }}
              sx={{ position: "absolute", right: 8, top: 8 }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ py: 2 }}>
            {/* Show already uploaded files */}
            {selectedRowId && (
              <div style={{ marginBottom: "16px" }}>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#4763E4",
                    marginBottom: "8px",
                  }}
                >
                  Previously Uploaded:
                </div>
                {(() => {
                  const row = filteredData.find(
                    (item) => item.id === selectedRowId
                  );
                  if (!row) return null;

                  if (uploadType === "video" && row.video_file) {
                    return (
                      <div
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#f0f8ff",
                          padding: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        <div>{row.video_file}</div>
                      </div>
                    );
                  } else if (uploadType === "mom" && row.mom_document) {
                    return (
                      <div
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#f0f8ff",
                          padding: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        <div>{row.mom_document}</div>
                      </div>
                    );
                  } else if (
                    uploadType === "image" &&
                    row.image_upload &&
                    row.image_upload.length > 0
                  ) {
                    return (
                      <div
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#f0f8ff",
                          padding: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        {/* <div><strong>Uploaded Images:</strong></div> */}
                        <ul
                          style={{
                            paddingLeft: "2px",
                            margin: "4px 0",
                            listStyle: "none", // This removes the dots/bullets
                          }}
                        >
                          {row.image_upload.map((img, idx) => (
                            <li key={idx}>{img}</li>
                          ))}
                        </ul>
                      </div>
                    );
                  }
                  return (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#666",
                        fontStyle: "italic",
                      }}
                    >
                      No files uploaded yet
                    </div>
                  );
                })()}
              </div>
            )}

            <div style={{ marginBottom: "12px" }}>
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: 500,
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                Select{" "}
                {uploadType === "video"
                  ? "Video"
                  : uploadType === "mom"
                    ? "MOM Document"
                    : "Images"}
                :
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                multiple={uploadType === "image"}
                accept={
                  uploadType === "video"
                    ? "video/mp4,video/mov,video/avi,video/mkv"
                    : uploadType === "mom"
                      ? ".pdf,.doc,.docx"
                      : "image/*"
                }
                style={{
                  fontSize: "12px",
                  padding: "6px",
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              />
            </div>

            <p style={{ color: "#666", fontSize: "11px", margin: "4px 0" }}>
              {uploadType === "video"
                ? "MP4, MOV, AVI, MKV (Max 100MB)"
                : uploadType === "mom"
                  ? "PDF, DOC, DOCX (Max 10MB)"
                  : "Image files (Max 5MB each)"}
            </p>

            {files.length > 0 && (
              <div
                style={{
                  fontSize: "11px",
                  marginTop: "8px",
                  backgroundColor: "#f9f9f9",
                  padding: "8px",
                  borderRadius: "4px",
                }}
              >
                <strong>New files to upload:</strong>
                <ul style={{ paddingLeft: "16px", margin: "4px 0" }}>
                  {files.map((f, idx) => (
                    <li key={idx}>
                      {f.name} ({formatFileSize(f.size)})
                      {uploadType === "video" && f.size > MAX_VIDEO_SIZE && (
                        <span style={{ color: "#ff6b6b", marginLeft: "8px" }}>
                          ⚠️ Exceeds 100MB limit
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <Button
              variant="contained"
              onClick={handleUpload}
              disabled={files.length === 0 || isUploading}
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#4763E4",
                fontSize: "12px",
                "&:hover": { backgroundColor: "#3a52c4" },
              }}
            >
              {isUploading ? "Uploading..." : "Upload"}
            </Button>

            {selectedRowId &&
              (() => {
                const row = filteredData.find(
                  (item) => item.id === selectedRowId
                );
                const hasExistingFile =
                  (uploadType === "video" && row?.video_file) ||
                  (uploadType === "mom" && row?.mom_document) ||
                  (uploadType === "image" && row?.image_upload?.length > 0);

                if (hasExistingFile) {
                  return (
                    <p
                      style={{
                        fontSize: "10px",
                        color: "#ff6b6b",
                        marginTop: "8px",
                        textAlign: "center",
                      }}
                    >
                      Note: Uploading new files will replace existing ones
                    </p>
                  );
                }
                return null;
              })()}
          </DialogContent>
        </Dialog>

        {/* Edit Modal */}
        <Dialog
          open={openEditModal}
          onClose={() => !isUploading && setOpenEditModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ py: 1.5, fontSize: "14px", fontWeight: 600 }}>
            Update Files for Meeting
            <IconButton
              onClick={() => !isUploading && setOpenEditModal(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ py: 2 }}>
            <div style={{ marginBottom: "16px" }}>
              <label>Date</label>
              <input
                type="date"
                value={editForm.sabha_date}
                onChange={(e) =>
                  setEditForm({ ...editForm, sabha_date: e.target.value })
                }
                min={!isMeetingDatePassed() ? todayYMD() : undefined}
                disabled={isMeetingDatePassed()}
                style={{
                  width: "100%",
                  padding: "6px",
                  marginBottom: "4px",
                  backgroundColor: isMeetingDatePassed() ? "#f5f5f5" : "white",
                  cursor: isMeetingDatePassed() ? "not-allowed" : "text",
                }}
              />

              {isMeetingDatePassed() && (
                <div style={{ fontSize: "10px", color: "#ff6b6b", marginBottom: "8px" }}>
                  Date cannot be edited as the meeting date has passed or is today
                </div>
              )}

              <label>Start Time</label>
              <TimePicker
                format="HH:mm"
                value={editForm.sabha_start_time ? dayjs(editForm.sabha_start_time, "HH:mm") : null}
                onChange={(time) => {
                  setEditForm({
                    ...editForm,
                    sabha_start_time: time ? time.format("HH:mm") : "",
                  });
                }}
                minuteStep={5}
                disabled={isMeetingDatePassed()}
                placeholder="Select Time"
                allowClear
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                style={{
                  width: "100%",
                  marginBottom: "4px",
                }}
                inputReadOnly={false}
                disabledTime={() => {
                  if (editForm.sabha_date === todayYMD()) {
                    const now = dayjs();
                    return {
                      disabledHours: () =>
                        Array.from({ length: now.hour() }, (_, i) => i),
                      disabledMinutes: (selectedHour) =>
                        selectedHour === now.hour()
                          ? Array.from({ length: now.minute() }, (_, i) => i)
                          : [],
                    };
                  }
                  return {};
                }}
              />

              {editForm.sabha_date === todayYMD() && (
                <div style={{ fontSize: "10px", color: "#ff6b6b", marginBottom: "8px" }}>
                  Cannot select past time for today's date
                </div>
              )}

              <label>Venue</label>
              <input
                type="text"
                value={editForm.venue}
                onChange={(e) =>
                  setEditForm({ ...editForm, venue: e.target.value })
                }
                placeholder="Enter venue"
                disabled={isMeetingDatePassed()}
                style={{
                  width: "100%",
                  padding: "6px",
                  backgroundColor: isMeetingDatePassed() ? "#f5f5f5" : "white",
                  cursor: isMeetingDatePassed() ? "not-allowed" : "text"
                }}
              />
            </div>
            {/* Show current files */}
            {editRowId &&
              (() => {
                const row = filteredData.find((item) => item.id === editRowId);
                if (!row) return null;

                return (
                  <div style={{ marginBottom: "16px" }}>
                    {/* <div style={{ fontSize: "12px", fontWeight: 600, color: "#4763E4", marginBottom: "8px" }}>
                    Current Files:
                  </div> */}

                    {/* Current Video */}
                    <div style={{ marginBottom: "12px" }}>
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: 500,
                          marginBottom: "4px",
                        }}
                      >
                        Current Video:
                      </div>
                      {row.video_file ? (
                        <div
                          style={{
                            fontSize: "11px",
                            backgroundColor: "#f0f8ff",
                            padding: "6px",
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{
                            wordBreak: "break-all",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flex: 1,
                          }}>{row.video_file}</span>
                          {signedUrls.video && (
                            <a
                              href={signedUrls.video}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: "10px",
                                color: "#4763E4",
                                textDecoration: "underline",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                              }}
                            >
                              View
                            </a>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          No video uploaded
                        </div>
                      )}
                    </div>

                    {/* Current MOM Document */}
                    <div style={{ marginBottom: "12px" }}>
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: 500,
                          marginBottom: "4px",
                        }}
                      >
                        Current MOM Document:
                      </div>
                      {row.mom_document ? (
                        <div
                          style={{
                            fontSize: "11px",
                            backgroundColor: "#f0f8ff",
                            padding: "6px",
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{
                            wordBreak: "break-all",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flex: 1,
                          }}>{row.mom_document}</span>
                          {signedUrls.mom && (
                            <a
                              href={signedUrls.mom}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: "10px",
                                color: "#4763E4",
                                textDecoration: "underline",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                              }}
                            >
                              View
                            </a>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          No Proceeding Book Uploaded
                        </div>
                      )}
                    </div>

                    {/* Current Images */}
                    <div style={{ marginBottom: "16px" }}>
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: 500,
                          marginBottom: "4px",
                        }}
                      >
                        Current Images:
                      </div>
                      {row.image_upload && row.image_upload.length > 0 ? (
                        <div
                          style={{
                            fontSize: "11px",
                            backgroundColor: "#f0f8ff",
                            padding: "6px",
                            borderRadius: "4px",
                          }}
                        >
                          {signedUrls.images.map((signedImg, idx) => {
                            const filename = signedImg.original.split('/').pop() || `image_${idx + 1}.jpg`;

                            return (
                              <div
                                key={idx}
                                style={{
                                  marginBottom: "4px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span style={{
                                  wordBreak: "break-all",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  flex: 1,
                                  fontSize: "11px",
                                }}>
                                  {filename}
                                </span>
                                <a
                                  href={signedImg.signed}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    fontSize: "10px",
                                    color: "#4763E4",
                                    textDecoration: "underline",
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                    cursor: "pointer",
                                  }}
                                >
                                  View
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          No meeting image uploaded
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}

            <div
              style={{
                borderTop: "1px solid #e0e0e0",
                paddingTop: "16px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#4763E4",
                  marginBottom: "8px",
                }}
              >
                Upload New Files:
              </div>

              {/* Video Upload */}
              <div style={{ marginBottom: "12px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "block",
                    marginBottom: "4px",
                  }}
                >
                  New Video
                </label>
                <input
                  type="file"
                  accept="video/*"
                  onChange={(e) =>
                    handleEditFileChange("video", e.target.files)
                  }
                  disabled={!currentRowData?.video_file}
                  style={{
                    fontSize: "11px",
                    display: "block",
                    marginTop: "4px",
                    width: "100%",
                    backgroundColor: !currentRowData?.video_file ? "#f5f5f5" : "inherit",
                    cursor: !currentRowData?.video_file ? "not-allowed" : "pointer"
                  }}
                />
                {!currentRowData?.video_file && (
                  <div style={{ fontSize: "10px", color: "#666", marginTop: "4px" }}>
                    Video can only be updated if it was previously uploaded.
                  </div>
                )}
                {editFiles.video && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#28a745",
                      marginTop: "4px",
                    }}
                  >
                    Selected: {editFiles.video.name} ({formatFileSize(editFiles.video.size)})
                    {editFiles.video.size > MAX_VIDEO_SIZE && (
                      <span style={{ color: "#ff6b6b", marginLeft: "8px" }}>
                        ⚠️ Exceeds 100MB limit
                      </span>
                    )}
                  </div>

                )}
              </div>

              {/* MOM Document Upload */}
              <div style={{ marginBottom: "12px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "block",
                    marginBottom: "4px",
                  }}
                >
                  New MOM Document
                </label>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => handleEditFileChange("mom", e.target.files)}
                  disabled={!currentRowData?.mom_document}
                  style={{
                    fontSize: "11px",
                    display: "block",
                    marginTop: "4px",
                    width: "100%",
                    backgroundColor: !currentRowData?.mom_document ? "#f5f5f5" : "inherit",
                    cursor: !currentRowData?.mom_document ? "not-allowed" : "pointer"
                  }}
                />
                {!currentRowData?.mom_document && (
                  <div style={{ fontSize: "10px", color: "#666", marginTop: "4px" }}>
                    MOM Document can only be updated if it was previously uploaded.
                  </div>
                )}
                {editFiles.mom && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#28a745",
                      marginTop: "4px",
                    }}
                  >
                    Selected: {editFiles.mom.name} (
                    {(editFiles.mom.size / 1024 / 1024).toFixed(2)} MB)
                  </div>
                )}
              </div>

              {/* Images Upload */}
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "block",
                    marginBottom: "4px",
                  }}
                >
                  New Images
                </label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) =>
                    handleEditFileChange("image", e.target.files)
                  }
                  disabled={!(currentRowData?.image_upload && currentRowData.image_upload.length > 0)}
                  style={{
                    fontSize: "11px",
                    display: "block",
                    marginTop: "4px",
                    width: "100%",
                    backgroundColor: !(currentRowData?.image_upload && currentRowData.image_upload.length > 0) ? "#f5f5f5" : "inherit",
                    cursor: !(currentRowData?.image_upload && currentRowData.image_upload.length > 0) ? "not-allowed" : "pointer"
                  }}
                />
                {!(currentRowData?.image_upload && currentRowData.image_upload.length > 0) && (
                  <div style={{ fontSize: "10px", color: "#666", marginTop: "4px" }}>
                    Images can only be updated if they were previously uploaded.
                  </div>
                )}
                {editFiles.images.new.length > 0 && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#28a745",
                      marginTop: "4px",
                    }}
                  >
                    Selected {editFiles.images.new.length} image(s):
                    <ul style={{ paddingLeft: "16px", margin: "4px 0" }}>
                      {editFiles.images.new.map((file, idx) => (
                        <li key={idx}>
                          {file.name} ({(file.size / 1024 / 1024).toFixed(2)}{" "}
                          MB)
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                fontSize: "11px",
                color: "#666",
                marginBottom: "12px",
                padding: "8px",
                backgroundColor: "#fff3cd",
                borderRadius: "4px",
              }}
            >
              <strong>Note:</strong> Only selected files will be updated.
              Existing files will be replaced with new ones.
            </div>

            <Button
              variant="contained"
              onClick={handleEditUpdate}
              disabled={
                isUploading ||
                (!getMeetingDetailsChanges().anyMeetingDetailChanged && !hasFilesToUpload())
              }
              fullWidth
              sx={{
                mt: 1,
                backgroundColor: "#4763E4",
                fontSize: "12px",
                "&:hover": { backgroundColor: "#3a52c4" },
                "&:disabled": { backgroundColor: "#ccc", color: "#666" },
              }}
            >
              {isUploading ? "Updating..." : "Update Selected Files"}
            </Button>
          </DialogContent>
        </Dialog>

        <ToastContainer />
      </div>

    </>
  );
};

export default GramSabhaMOM;
